var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 64,
    viewBox: "0 0 66 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.505981 0V60.1042L18.6353 36.0952V0H0.505981Z",
    fill: "#D5B086"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0511 34.9519H30.2315L55.8736 0.226105H46.0741L18.6351 36.0952L44.2776 60.1042H66L39.0511 34.9519Z",
    fill: "#D5B086"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6609 63.1528H25.0594V52.7543H14.6609V63.1528Z",
    fill: "#D5B086"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.d291f96b112ef0ca1579b9d42a5f6108.svg";
export { ForwardRef as ReactComponent };